import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function checklistReducer(state = initialState.checklists, action){
  switch(action.type) {
    case types.LOAD_CHECKLIST_SUCCESS:
      return [...action.checklists];
    default:
      return state;
  }
}
